import React from 'react';

const BriefcaseIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 4.66666H2.66667C1.93029 4.66666 1.33334 5.26361 1.33334 5.99999V12.6667C1.33334 13.403 1.93029 14 2.66667 14H13.3333C14.0697 14 14.6667 13.403 14.6667 12.6667V5.99999C14.6667 5.26361 14.0697 4.66666 13.3333 4.66666Z"
      stroke="#c6a664"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 14V3.33333C10.6667 2.97971 10.5262 2.64057 10.2761 2.39052C10.0261 2.14048 9.68696 2 9.33334 2H6.66667C6.31305 2 5.97391 2.14048 5.7239 2.39052C5.47381 2.64057 5.33334 2.97971 5.33334 3.33333V14"
      stroke="#c6a664"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BriefcaseIcon;
